import React from 'react';
 
import { MdArrowBackIos } from "react-icons/md";
import { useNavigate } from 'react-router-dom';




const UnderDevelopmentPage = () => {
  const navigate = useNavigate()
  return (
    <div
      className="w-full h-[100vh] flex flex-col items-center justify-center text-center px-10 lg:px-20"
      style={{
        backgroundImage: "conic-gradient(from 285deg, #2D2D2D,  #141414 )",
      }}
    >
        <h1></h1>
      <h1 className="text-xl lg:text-3xl font-extrabold text-white font-extrabold  text-center ">
    "  Sorry, currently there is no course for this. It will be provided to you soon..."
      </h1>
      <button onClick={()=>navigate(-1)} className='hover:bg-richblack-50 px-6 py-3 border-2 border-white text-white mt-4 rounded-xl flex gap-1 justify-center items-center ' >
       
<MdArrowBackIos />Back
      </button>
    </div>
  );
};

export default UnderDevelopmentPage;
